import accPlot from "../../../../content/posts/data-release-notes/cliveome_2021.05/accuracy.plt.jsx";
import lenPlot from "../../../../content/posts/data-release-notes/cliveome_2021.05/cumlength.plt.jsx";
import * as React from 'react';
export default {
  accPlot,
  lenPlot,
  React
};